// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"4df8578b","569":"f8224f86","604":"36c3036c","640":"52835745","787":"3d7f4c59"}[chunkId] + ".chunk.js";
};